export default __webpack_public_path__ + "static/media/undraw_bike_ride_7xit.fc633169.svg";